module.exports = __webpack_public_path__ + "static/antd-message-19cc8f268895cc6f51a133e57f1d101c.png";